import $ from "jquery";

export const progressBar = () => {
    const leftMenuItemParent = $(".left-menu--progress-bar");
    let visibleItem;

    leftMenuItemParent.find(".left-menu__item").removeClass('left-menu__item--active');

    $(".lessons__item").each(function () {
        if ($(window).scrollTop() + $(window).height() >= $(this).offset().top + $(this).height() / 4) {
            visibleItem = $(this);
        }
    });

    if (visibleItem !== undefined) {
        const lessonsItemId = visibleItem.attr('id');

        leftMenuItemParent.find($('a[href*=' + lessonsItemId + ']')).parent().addClass('left-menu__item--active');
    }
};
